import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogInputAutoCompleteCheckControlled from '@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { isNullUndefined } from '@/main/services/utils';
import { getInsurers, resetReducerInsurers, useInsurerReducer } from '@/main/store/insurer';
import { IFormFiltersDynamicExport } from '../modalExportDynamicReport';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';

interface IVariableTypeInsurerProps extends GeneralVariableType { }
function VariableTypeInsurer({
  filter
}: IVariableTypeInsurerProps) {
  const dispatch = useDispatch();
  const {
    keyReducer,
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
    watcherCountry
  } = useDynamicFiltersExport();
  const { isolated: insurersReducer } = useInsurerReducer(keyReducer);
  const {
    control,
    resetField,
    setValue
  } = useFormContext<IFormFiltersDynamicExport>();

  useEffect(() => {
    if (isNullUndefined(watcherCountry)) return;

    dispatch(getInsurers({ guidCountry: String(watcherCountry.key), idStatusRegister: StatusRegisterEnum.Active }, keyReducer));

    return () => {
      dispatch(resetReducerInsurers());
    }
  }, [JSON.stringify(watcherCountry?.key)])

  const disabledInsurer = isNullUndefined(insurersReducer.data) || insurersReducer.data.length === 1
  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  return (
    <>
      <KogInputAutoCompleteCheckControlled
        name={`filtersDinamics.${indexField}.value`}
        disableSelectAll
        control={control}
        options={insurersReducer.data || []}
        label={filter.responseServer.filterName}
        disabled={disabledInsurer}
        isLoading={insurersReducer.isLoading}
        setValueCustom={setValue}
        controllerProps={{ rules: { required: filter.responseServer.mandatory } }}
        customInputProps={{ required: filter.responseServer.mandatory, id: idScreen('select-insurer') }}
        onChangeCustom={(value, optionChanged, reason) => { }}
      />
    </>
  )

}

export default VariableTypeInsurer